import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import useEmblaCarousel from 'embla-carousel-react';
import Image from 'next/image';
import { type MouseEvent, useEffect, useState } from 'react';
import { BsArrowLeft } from 'react-icons/bs';
import { FaHeart } from 'react-icons/fa6';
import { useIsMounted, useScrollLock } from 'usehooks-ts';
import { NextButton, PrevButton, useCarouselArrows } from '@/features/listing/components/listing-card/listing-carousel-arrows/use-carousel-arrows';
import { SelectedSnapDisplay, useSelectedSnapDisplay } from '@/features/listing/components/listing-detailed/listing-detail-gallery/listing-detail-carousel-counter/listing-detail-carousel-counter';
import { type ListingDetailGalleryProps } from '@/features/listing/components/listing-detailed/listing-detail-gallery/listing-detail-gallery';
import styles from './listing-detail-all-photos.module.scss';
interface ListingDetailAllPhotosProps extends Omit<ListingDetailGalleryProps, 'listingType'> {
  onClose: () => void;
  onBookmarkClick: (event: MouseEvent<HTMLButtonElement>) => void;
}
export default function ListingDetailAllPhotos(props) {
  const $ = _c(53);
  const {
    alt,
    images,
    isBookmarked,
    onBookmarkClick,
    onClose
  } = props;
  const isMounted = useIsMounted();
  const [isPhotosCarouselShow, setIsPhotosCarouselShow] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      align: "start"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t0);
  const {
    nextBtnDisabled,
    onNextButtonClick,
    onPrevButtonClick,
    prevBtnDisabled
  } = useCarouselArrows(emblaApi);
  const {
    selectedSnap,
    snapCount
  } = useSelectedSnapDisplay(emblaApi);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      autoLock: false
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    lock,
    unlock
  } = useScrollLock(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsPhotosCarouselShow(true);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handlePhotosCarouselShow = t2;
  const addToImgUrlExtraParams = _temp;
  let t3;
  if ($[3] !== isPhotosCarouselShow || $[4] !== onClose) {
    t3 = () => {
      if (isPhotosCarouselShow) {
        setIsPhotosCarouselShow(false);
      } else {
        onClose();
      }
    };
    $[3] = isPhotosCarouselShow;
    $[4] = onClose;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleModalBackIconClick = t3;
  let t4;
  if ($[6] !== lock || $[7] !== unlock) {
    t4 = () => {
      lock();
      return () => {
        unlock();
      };
    };
    $[6] = lock;
    $[7] = unlock;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isMounted || $[10] !== lock || $[11] !== unlock) {
    t5 = [isMounted, lock, unlock];
    $[9] = isMounted;
    $[10] = lock;
    $[11] = unlock;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  useEffect(t4, t5);
  let t6;
  if ($[13] !== onClose || $[14] !== onNextButtonClick || $[15] !== onPrevButtonClick) {
    t6 = () => {
      const handleKeydown = event => {
        bb13: switch (event.key) {
          case "Escape":
            {
              onClose();
              break bb13;
            }
          case "ArrowRight":
            {
              onNextButtonClick(event);
              break bb13;
            }
          case "ArrowLeft":
            {
              onPrevButtonClick(event);
              break bb13;
            }
          default:
        }
      };
      globalThis.addEventListener("keydown", handleKeydown);
      return () => {
        globalThis.removeEventListener("keydown", handleKeydown);
      };
    };
    $[13] = onClose;
    $[14] = onNextButtonClick;
    $[15] = onPrevButtonClick;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  useEffect(t6);
  const t7 = isPhotosCarouselShow && styles.listingDetailAllPhotos__isPhotosCarouselShow;
  let t8;
  if ($[17] !== t7) {
    t8 = cx(styles.listingDetailAllPhotos, t7);
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = cx(styles.listingDetailAllPhotos_backIcon);
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <BsArrowLeft />;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== handleModalBackIconClick) {
    t11 = <button aria-label="close modal" className={t9} onClick={handleModalBackIconClick}>{t10}</button>;
    $[21] = handleModalBackIconClick;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== isPhotosCarouselShow || $[24] !== selectedSnap || $[25] !== snapCount) {
    t12 = isPhotosCarouselShow && <SelectedSnapDisplay selectedSnap={selectedSnap} snapCount={snapCount} />;
    $[23] = isPhotosCarouselShow;
    $[24] = selectedSnap;
    $[25] = snapCount;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const t13 = isBookmarked && styles.listingDetailAllPhotos_bookmarkIcon__isBookmarked;
  let t14;
  if ($[27] !== t13) {
    t14 = cx(styles.listingDetailAllPhotos_bookmarkIcon, t13);
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t14) {
    t15 = <FaHeart className={t14} />;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== onBookmarkClick || $[32] !== t15) {
    t16 = <button className={styles.listingDetailAllPhotos_bookmark} aria-label="favorite" onClick={onBookmarkClick}>{t15}</button>;
    $[31] = onBookmarkClick;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t11 || $[35] !== t12 || $[36] !== t16) {
    t17 = <div className={styles.listingDetailAllPhotos_header}>{t11}{t12}{t16}</div>;
    $[34] = t11;
    $[35] = t12;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== alt || $[39] !== emblaRef || $[40] !== images || $[41] !== isPhotosCarouselShow || $[42] !== nextBtnDisabled || $[43] !== onNextButtonClick || $[44] !== onPrevButtonClick || $[45] !== prevBtnDisabled) {
    t18 = isPhotosCarouselShow ? <section className={styles.embla}><div className={styles.embla__viewport} ref={emblaRef}><div className={styles.embla__container}>{images.map(image => <div key={image.id} className={styles.embla__slide}><img className={cx(styles.embla__slide__img)} src={addToImgUrlExtraParams(image.path)} alt={alt} /></div>)}</div></div><div className={styles.embla__buttons}><PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} isListingDetailPreview={true} /><NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} isListingDetailPreview={true} /></div></section> : <div className={styles.listingDetailAllPhotos_grid}>{images.map(photo => <button onClick={handlePhotosCarouselShow} key={photo.id} className={styles.listingDetailAllPhotos_item}><Image src={photo.path} alt={alt} quality={75} fill={true} /></button>)}</div>;
    $[38] = alt;
    $[39] = emblaRef;
    $[40] = images;
    $[41] = isPhotosCarouselShow;
    $[42] = nextBtnDisabled;
    $[43] = onNextButtonClick;
    $[44] = onPrevButtonClick;
    $[45] = prevBtnDisabled;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== t17 || $[48] !== t18) {
    t19 = <div className={styles.listingDetailAllPhotos_wrapper}>{t17}{t18}</div>;
    $[47] = t17;
    $[48] = t18;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== t19 || $[51] !== t8) {
    t20 = <div className={t8}>{t19}</div>;
    $[50] = t19;
    $[51] = t8;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  return t20;
}
function _temp(source) {
  const url = new URL(source);
  url.searchParams.set("auto", "webp");
  return url.toString();
}